<!--
 * @Author: 陈梦男
 * @Date: 2024-05-22 14:44:21
 * @LastEditTime: 2024-12-25 11:22:36
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 报告数据管理--查询条件
 * @FilePath: \web\src\components\PolicyManager\InformationManager\search.vue
-->
<template>
  <section class="trend-search">
    <section class="type" v-if="type === 'zx'">
      <section class="search-item" style="width: 2.2rem">
        <div class="search-item-text">资讯名称：</div>
        <a-input placeholder="请输入资讯名称" v-model:value="requestParams.name" />
      </section>
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">资讯时间：</div>
        <a-range-picker v-model:value="requestParams.timeRange" />
      </section>
      <section class="search-item" style="width: 2.2rem">
        <div class="search-item-text">国内国际：</div>
        <a-select placeholder="矿种" v-model:value="requestParams.type"
          :options="[{ label: '全部', value: '' }, { label: '国内', value: '国内' }, { label: '国际', value: '国际' }]" />
      </section>
    </section>
    <section class="type" v-if="type === 'yq'">
      <section class="search-item" style="width: 2.2rem">
        <div class="search-item-text">名称：</div>
        <a-input placeholder="请输入名称" v-model:value="requestParams.name" />
      </section>
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">舆情时间：</div>
        <a-range-picker v-model:value="requestParams.timeRange" />
      </section>
    </section>
    <section class="type" v-if="type === 'zn'">
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">国家类别：</div>
        <a-select placeholder="矿种" v-model:value="requestParams.continent" :options="areaList" />
      </section>
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">国家：</div>
        <a-input placeholder="请输入国家" v-model:value="requestParams.countryName" />
      </section>
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">类别：</div>
        <a-select placeholder="类别" v-model:value="requestParams.type" :options="typeList" />
      </section>
    </section>
    <section class="type" v-if="type === 'fg'">
      <!-- <section class="search-item" style="width: 2.2rem">
        <div class="search-item-text">来源：</div>
        <a-input placeholder="请输入来源" v-model:value="requestParams.title" />
      </section> -->
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">国家类别：</div>
        <a-select placeholder="矿种" v-model:value="requestParams.continent" :options="areaList" />
      </section>
      <section class="search-item" style="width: 3.2rem">
        <div class="search-item-text">国家：</div>
        <a-input placeholder="请输入国家" v-model:value="requestParams.countryName" />
      </section>
    </section>
    <slot name="trendBtns">
      <div class="btn-wrapper">
        <div class="reset-btn btn-item" @click="resetSearch">重置</div>
        <div class="search-btn btn-item" @click="submitSearch()">查询</div>
      </div>
    </slot>
  </section>
</template>

<script setup>
import { ref, reactive, defineProps, defineEmits, } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'zx',
  },
});
const areaList = [
  { label: '全部', value: '' },
  { label: '南部非洲', value: '南部非洲' },
  { label: '北部非洲', value: '北部非洲' },
  { label: '东南亚和南亚', value: '东南亚和南亚' },
  { label: '中亚和西亚', value: '中亚和西亚' },
  { label: '美洲和大洋洲', value: '美洲和大洋洲' },
  { label: '东北亚和欧洲', value: '东北亚和欧洲' },
  { label: '其他', value: '其他' },
];
const typeList = [
  { label: '全部', value: '' },
  { label: '国别指南', value: '0' },
  { label: '税收指南', value: '1' },
]
const timeRange = ref([]);

const requestParams = reactive({
  name: '',
  continent: '',
  countryName: null,
  type: '',
  timeRange: null,
  title: ''
});
const emit = defineEmits(['submit',]);

/**
 * @description 查询
 */
const submitSearch = async () => {

  await emit('submit', requestParams);
};

/**
 * @description 重置
 */
const resetSearch = async () => {
  timeRange.value = [];
  requestParams.name = '';
  requestParams.continent = '';
  requestParams.countryName = null;
  requestParams.type = '';
  requestParams.timeRange = null;
  requestParams.title = '';
  await emit('submit', {});
};


</script>

<style lang='scss'>
.trend-search {
  display: flex;

  .type {
    display: flex;

  }

  .search-item {
    width: 1.8rem;
    height: 0.34rem;
    margin-right: 0.05rem;
    display: flex;

    .search-item-text {
      color: #fff;
      width: 1.1rem;
      text-align: right;
      height: 0.34rem;
      line-height: 0.34rem;
    }
  }

  /* 输入框 */
  .ant-input {
    color: white;
    background-color: rgba(91, 76, 39, 0.4);
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    border: transparent;
  }

  .ant-input-suffix {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: .02rem;
  }

  /** 下拉框 */
  .ant-select {
    width: 100%;
    height: 100%;

    .ant-select-selector {
      height: 100%;
    }

    .ant-select-arrow {
      color: #fff;
    }

    .ant-select-selection-item {
      line-height: .34rem;
    }

    // 背景
    &:not(.ant-select-customize-input) .ant-select-selector {
      background-color: rgba(91, 76, 39, 0.4);
      border: none;
      color: #fff;
    }

    /* 描述 */
    .ant-select-selection-placeholder {
      line-height: .34rem;
      color: #fff;
      padding-right: 0;
    }
  }

  /* 输入框 */
  .ant-input {
    color: white;
    background-color: rgba(91, 76, 39, 0.4);
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    border: transparent;
    padding-top: 0rem;
    padding-bottom: 0rem;
    height: 100%;
  }

  .ant-input-suffix {
    width: 0.12rem;
    height: 0.12rem;
    margin-top: .02rem;
  }

  .btn-wrapper {
    height: 0.32rem;
    line-height: 0.32rem;
    margin-left: 0.2rem;
    color: #ffffff;
    display: flex;
    padding: 0;

    .btn-item {
      width: 0.9rem;
      text-align: center;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }

    .reset-btn {
      // background-color: #535962;
      background-image: url(~@/static/images/dataManagement/reset_btn.png);
      background-size: 100% 100%;
      margin-right: 0.05rem;
    }

    .search-btn {
      // background-color: #efb227;
      background-image: url(~@/static/images/dataManagement/submit_btn.png);
      background-size: 100% 100%;
    }
  }
}
</style>